'use client'

import { useState, useEffect } from 'react'
import { Collapse, Slider } from 'antd'
import Link from 'next/link'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import styles from './FilterAll.module.css'

const { Panel } = Collapse

export default function FilterAll({
  categories = [],
  currentCategoryID,
  currentBrandID,
  brands = [],
  currentActiveBrands = [],
  onChangeBrands,
  onChangePrice,
}) {
  const [price, setPrice] = useState([20, 70987])
  const [expandedKeys, setExpandedKeys] = useState([])
  const [activePanel, setActivePanel] = useState('category')

  const handleCloseAside = () => {
    const pageOverlay = document.getElementById('pageOverlay')
    const shopFilter = document.getElementById('shopFilterAside')
    setTimeout(() => {
      pageOverlay?.classList.remove('page-overlay_visible')
      shopFilter?.classList.remove('aside_visible')
    }, 50)
  }

  const toggleBrands = (brand) => {
    let newActiveBrands = []
    if (currentActiveBrands.includes(brand)) {
      newActiveBrands = currentActiveBrands.filter((b) => b !== brand)
    } else {
      newActiveBrands = [...currentActiveBrands, brand]
    }
    onChangeBrands?.(newActiveBrands)
  }

  const handleOnChange = (value) => {
    setPrice(value)
    onChangePrice?.(value)
  }

  const findParentPath = (nodes, targetID, path = []) => {
    for (const node of nodes) {
      const newPath = [...path, node.CategoryID]
      if (String(node.CategoryID) === String(targetID)) return newPath
      if (node.Children?.length) {
        const result = findParentPath(node.Children, targetID, newPath)
        if (result) return result
      }
    }
    return null
  }

  useEffect(() => {
    if (!currentCategoryID || !categories?.length) return
    const path = findParentPath(categories, currentCategoryID)
    if (path) setExpandedKeys(path)
  }, [currentCategoryID, categories])

  const toggleExpand = (key) => {
    setExpandedKeys((prev) =>
      prev.includes(key) ? prev.filter((x) => x !== key) : [...prev, key]
    )
  }

  const renderCategory = (items = [], level = 0) => {
    return items.map((cat) => {
      const hasChildren = Array.isArray(cat.Children) && cat.Children.length > 0
      const isActive = String(cat.CategoryID) === String(currentCategoryID)
      const paddingLeft = level * 18
      const isExpanded = expandedKeys.includes(cat.CategoryID)

      return (
        <div key={cat.CategoryID} className="fade-in-item">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{
              paddingLeft,
              paddingTop: 12,
              paddingBottom: 12,
              cursor: hasChildren ? 'pointer' : 'default',
            }}
            onClick={() => hasChildren && toggleExpand(cat.CategoryID)}
          >
            {hasChildren ? (
              <span
                style={{
                  color: isActive ? '#1677ff' : '#000',
                  fontWeight: isActive ? '600' : '400',
                  fontSize: '15px',
                  flex: 1,
                  userSelect: 'none',
                }}
              >
                {cat.CategoryName}
              </span>
            ) : (
              <Link
                href={`/product-list?categoryid=${cat.CategoryID}`}
                onClick={handleCloseAside}
                style={{
                  textDecoration: 'none',
                  color: isActive ? '#1677ff' : '#000',
                  fontWeight: isActive ? '600' : '400',
                  fontSize: '15px',
                  flex: 1,
                }}
              >
                {cat.CategoryName}
              </Link>
            )}

            {hasChildren && (
              <span style={{ fontSize: '11px', paddingRight: '4px' }}>
                {isExpanded ? <DownOutlined /> : <RightOutlined />}
              </span>
            )}
          </div>

          {/* ✅ 子選單加滑動動畫 */}
          {hasChildren && (
            <div
              className={`${styles.subMenu} ${isExpanded ? styles.open : ''}`}
            >
              {renderCategory(cat.Children, level + 1)}
            </div>
          )}
        </div>
      )
    })
  }

  return (
    <div className={styles.filterAllContainer} style={{ background: '#fff' }}>
      <Collapse
        accordion
        bordered={false}
        activeKey={activePanel}
        onChange={(key) => {
          setActivePanel(key)
          if (key[0] === 'brand' || key[0] === 'price') {
            window.scrollTo({ top: 0, behavior: 'instant' })
          }
        }}
        expandIconPosition="end"
        style={{ transition: 'all 0.4s ease' }}
        ghost
      >
        <Panel
          header={<span className="fw-semibold fs-5">類別</span>}
          key="category"
        >
          <div style={{ paddingLeft: '10px' }}>
            {renderCategory(categories)}
          </div>
        </Panel>

        {/* <Panel
          header={<span className="fw-semibold fs-5">品牌</span>}
          key="brand"
        >
          <ul className="list-unstyled ps-2 mb-0">
            {brands.map((elm) => (
              <li key={elm.BrandID} className="py-2">
                <Link
                  href={`/product-list?brandid=${elm.BrandID}`}
                  onClick={() => {
                    toggleBrands(elm)
                    handleCloseAside()
                  }}
                  style={{
                    textDecoration: 'none',
                    color:
                      currentBrandID === String(elm.BrandID)
                        ? '#1677ff'
                        : '#000',
                    fontSize: '15px',
                  }}
                >
                  {elm.BrandName}
                </Link>
              </li>
            ))}
          </ul>
        </Panel> */}
      </Collapse>
    </div>
  )
}
